// Tarayicinin yerlesik Notification API'si - sekme/tarayici acikken calisir,
// kapali sekmede/tarayicida calismaz.
//
// KAPALIYKEN DE GELMESI icin Web Push + service worker var (utils/webPush.js).
// Bu dosya onun YERINE gecmiyor, ALTINDA duruyor: push'a abone OLMAYAN
// kullanicilar (izin vermemis, ya da tarayicisi desteklemiyor) en azindan
// sekme acikken bildirimi gorsun.
export const requestNotificationPermission = () => {
  if (typeof Notification === 'undefined') return;
  if (Notification.permission === 'default') {
    Notification.requestPermission().catch(() => {});
  }
};

/**
 * Web push aboneligi VARSA istemci tarafi gosterimi susturulur.
 *
 * Aksi halde ayni bildirim IKI KEZ cikiyor: biri buradan (sayfa acikken
 * yoklama ile), biri service worker'dan (push ile). Kullanici icin bu
 * "sistem bozuk" gorunumu yaratir.
 *
 * Kontrol burada yapiliyor, layout'larda degil - iki layout (MainLayout ve
 * ParentLayout) ayni fonksiyonu cagiriyor ve kural ikisine birden
 * uygulanmali. Layout'lara tek tek konsaydi biri unutulurdu; bu projede
 * o desen daha once defalarca sapti.
 */
const pushAboneligiVarMi = async () => {
  try {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return false;
    const reg = await navigator.serviceWorker.getRegistration();
    if (!reg) return false;
    return !!(await reg.pushManager.getSubscription());
  } catch {
    return false;
  }
};

export const showBrowserNotifications = async (items, iconUrl) => {
  if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;
  if (await pushAboneligiVarMi()) return;

  items.forEach((n) => {
    try {
      const notif = new Notification(n.title || 'Yeni bildirim', {
        body: n.body || '',
        icon: iconUrl || '/logo192.png',
        tag: `arys-notification-${n.id}`,
      });
      notif.onclick = () => {
        window.focus();
        notif.close();
      };
    } catch {
      // Bazi tarayicilar/ortamlar Notification constructor'ini
      // desteklemiyor - ozellikle iOS Safari ve ana ekran uygulamalari,
      // orada YALNIZCA service worker uzerinden bildirim gosterilebiliyor.
      // Sessizce yut; push kanali zaten o durumu karsiliyor.
    }
  });
};
